import {useEffect, useId, useState} from "react";
import {ThinCaretDownIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {GradeToString} from "./list";
import {TimePicker} from "../../../components/timepicker/timepicker";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {Apis} from "../../../components/api/url";
import {FixStringWithNumbers} from "../../../components/techaran/money";

export const AddEditStudentModal = (props: {
    active: boolean,
    closeHandler: any,
    studentId: number,
    isEdit: boolean,
    onDone: any
}) => {
    const [loaded, setLoaded] = useState(true);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [national, setNational] = useState('');
    const [grade, setGrade] = useState('1');
    const [birthSerial, setBirthSerial] = useState('');
    const [homeTell, setHomeTell] = useState('');
    const [fatherName, setFatherName] = useState('');
    const [fatherCert, setFatherCert] = useState('');
    const [fatherTell, setFatherTell] = useState('');
    const [fatherJob, setFatherJob] = useState('');
    const [motherName, setMotherName] = useState('');
    const [motherTell, setMotherTell] = useState('');
    const [motherCert, setMotherCert] = useState('');
    const [motherJob, setMotherJob] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [address, setAddress] = useState('');
    const [expanded, setExpanded] = useState(false);
    const ids = {
        firstName: useId(),
        lastName: useId(),
        national: useId(),
        grade: useId(),
        birthSerial: useId(),
        homeTell: useId(),
        birthDate: useId(),
        fatherName: useId(),
        fatherCert: useId(),
        fatherTell: useId(),
        fatherJob: useId(),
        motherName: useId(),
        motherTell: useId(),
        motherCert: useId(),
        motherJob: useId(),
        zipcode: useId(),
        address: useId(),
    };
    const [errors, setErrors] = useState({
        firstName: false,
        lastName: false,
        national: false,
        grade: false,
        birthSerial: false,
        homeTell: false,
        birthDate: false,
        fatherName: false,
        fatherCert: false,
        fatherTell: false,
        fatherJob: false,
        motherName: false,
        motherTell: false,
        motherCert: false,
        motherJob: false,
        zipcode: false,
        address: false,
    });
    const fetchData = () => {
        setLoaded(false);
        const stuId = props.studentId;
        PostJSON(
            Apis.server + '/core/admins/students/get-for-edit',
            {
                id: stuId,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                firstname: string,
                lastname: string,
                national: string,
                grade: number,
                fatherName: string,
                birthSerial: string,
                homeTell: string,
                birthDate: string,
                fatherCert: string,
                fatherTell: string,
                fatherJob: string,
                motherName: string,
                motherTell: string,
                motherCertificate: string,
                motherJob: string,
                zipcode: string,
                address: string,
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setExpanded(true);
                setHomeTell(d.homeTell);
                setFirstName(d.firstname);
                setLastName(d.lastname);
                setNational(d.national);
                setGrade(d.grade.toString());
                setFatherName(d.fatherName);
                setBirthSerial(d.birthSerial);
                setTime({
                    time: [0, 0],
                    date: d.birthDate === '' || d.birthDate === '0000-00-00' ? '2000-01-01' : d.birthDate,
                });
                setFatherCert(d.fatherCert);
                setFatherTell(d.fatherTell);
                setFatherJob(d.fatherJob);
                setMotherName(d.motherName);
                setMotherTell(d.motherTell);
                setMotherCert(d.motherCertificate);
                setMotherJob(d.motherJob);
                setZipcode(d.zipcode);
                setAddress(d.address);
            },
            () => {
                HideProgressLoading();
                ShowProgressLoading();
                setLoaded(true);
                props.closeHandler();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.isEdit;
        if (isActive) {
            setExpanded(false);
            setErrors({
                firstName: false,
                lastName: false,
                national: false,
                grade: false,
                birthSerial: false,
                homeTell: false,
                birthDate: false,
                fatherName: false,
                fatherCert: false,
                fatherTell: false,
                fatherJob: false,
                motherName: false,
                motherTell: false,
                motherCert: false,
                motherJob: false,
                zipcode: false,
                address: false,
            });
            if (isEdit) {
                setLoaded(false);
                setTimeout(fetchData, 1000);
            } else {
                setLoaded(true);
                setFirstName('');
                setLastName('');
                setNational('');
                setBirthSerial('');
                setHomeTell('');
                setFatherName('');
                setFatherCert('');
                setFatherTell('');
                setFatherJob('');
                setMotherName('');
                setTime({
                    time: [0, 0, 0],
                    date: '2000-01-01',
                });
                setMotherTell('');
                setMotherCert('');
                setMotherJob('');
                setZipcode('');
                setAddress('');
            }
            document.body.classList.add('body-no-scroll');
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active, props.isEdit]);
    const saveChanges = () => {
        let data = {
            id: props.studentId,
            firstName: firstName,
            lastName: lastName,
            national: FixStringWithNumbers(national),
            grade: parseInt(grade === '' ? '0' : grade) as number | string,
            birthSerial: FixStringWithNumbers(birthSerial),
            homeTell: FixStringWithNumbers(homeTell),
            fatherName: fatherName,
            fatherCert: fatherCert,
            fatherTell: FixStringWithNumbers(fatherTell),
            motherName: motherName,
            motherTell: FixStringWithNumbers(motherTell),
            motherCert: motherCert,
            motherJob: motherJob,
            zipcode: FixStringWithNumbers(zipcode),
            address: FixStringWithNumbers(address),
            birthDate: time.date,
            fatherJob: fatherJob,
        };
        let err = {
            firstName: false,
            lastName: false,
            national: false,
            grade: false,
            birthSerial: false,
            homeTell: false,
            birthDate: false,
            fatherName: false,
            fatherCert: false,
            fatherTell: false,
            fatherJob: false,
            motherName: false,
            motherTell: false,
            motherCert: false,
            motherJob: false,
            zipcode: false,
            address: false,
        };
        let stop = false;
        if (data.firstName.length < 2) {
            stop = true;
            err.firstName = true;
        }
        if (data.lastName.length < 2) {
            stop = true;
            err.lastName = true;
        }
        if (data.national.length < 4) {
            stop = true;
            err.national = true;
        }
        if (data.grade < 1 || data.grade > 12) {
            stop = true;
            err.grade = true;
        }
        if (data.birthSerial.length < 1) {
            stop = true;
            err.birthSerial = true;
        }
        data.grade = data.grade.toString();
        const isEdit = props.isEdit;
        setErrors(err);
        if (stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + ('/core/admins/students/' + (isEdit ? 'edit' : 'add')),
            data,
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'national')
                        setErrors(v => {
                            let x = {...v};
                            x.national = true;
                            return x;
                        });
                    else if (d.reason === 'tell')
                        ShowSnackbar('لطفا تلفن همراه حداقل یکی از والدین را وارد کنید.', 'باشه', 5000);
                    else
                        ShowSnackbar('لطفا موارد خواسته شده را تکمیل کنید.', 'باشه', 5000);
                    return;
                }
                props.closeHandler();
                props.onDone();
                ShowSnackbar(isEdit ? 'مشخصات دانش‌آموز ویرایش شد.' : 'دانش‌آموز جدید افزوده شد.', 'باشه', 5000);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
                props.closeHandler();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [time, setTime] = useState({
        time: [0, 0, 0],
        date: '2024-01-01',
    });
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '') + (expanded ? ' web-modal-xxl' : '')}
                 style={{top: 20}}>
                <div className="web-modal-header">
                    <div>
                        <b>{props.isEdit ? 'ویرایش دانش‌آموز' : 'دانش‌آموز جدید'}</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    {
                        loaded ?
                            <div className="add-student">
                                <div className="container">
                                    <div className="row">
                                        <div className={"col-lg-" + (expanded ? '4' : '12')}>
                                            <label htmlFor={ids.firstName}>نام:</label>
                                            <input type="text"
                                                   id={ids.firstName}
                                                   className={"form-control" + (errors.firstName ? ' is-invalid' : '')}
                                                   value={firstName}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setFirstName(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.firstName = false;
                                                           return x;
                                                       });
                                                   }}
                                                   onKeyUp={e => {
                                                       if (e.which === 13)
                                                           (document.getElementById(ids.lastName) as HTMLInputElement).focus();
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.firstName ? 'd-block' : 'd-none')}>
                                                لطفا حداقل ۲ کاراکتر وارد کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.lastName}>نام خانوادگی:</label>
                                            <input type="text"
                                                   id={ids.lastName}
                                                   className={"form-control" + (errors.lastName ? ' is-invalid' : '')}
                                                   value={lastName}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setLastName(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.lastName = false;
                                                           return x;
                                                       });
                                                   }}
                                                   onKeyUp={e => {
                                                       if (e.which === 13)
                                                           (document.getElementById(ids.national) as HTMLInputElement).focus();
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.lastName ? 'd-block' : 'd-none')}>
                                                لطفا حداقل ۲ کاراکتر وارد کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.national}>کد ملی:</label>
                                            <input type="text"
                                                   id={ids.national}
                                                   className={"form-control" + (errors.national ? ' is-invalid' : '')}
                                                   value={national}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setNational(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.national = false;
                                                           return x;
                                                       });
                                                   }}
                                                   onKeyUp={e => {
                                                       if (e.which === 13)
                                                           (document.getElementById(ids.grade) as HTMLInputElement).focus();
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.national ? 'd-block' : 'd-none')}>
                                                کد ملی صحیح نیست.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.grade}>پایه تحصیلی:</label>
                                            <select id={ids.grade}
                                                    value={grade}
                                                    className={"form-control" + (errors.grade ? ' is-invalid' : '')}
                                                    onChange={e => {
                                                        let t = e.currentTarget.value;
                                                        setGrade(t);
                                                        setErrors(v => {
                                                            let x = {...v};
                                                            x.grade = false;
                                                            return x;
                                                        });
                                                    }}>
                                                {
                                                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((g, i) =>
                                                        <option key={"Ksj39fnd" + i} value={g.toString()}>
                                                            {GradeToString(g)}
                                                        </option>
                                                    )
                                                }
                                            </select>
                                            <div
                                                className={"invalid-feedback " + (errors.grade ? 'd-block' : 'd-none')}>لطفا
                                                یک
                                                پایه تحصیلی را انتخاب کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.birthSerial}>شماره سریال شناسنامه:</label>
                                            <input type="text"
                                                   id={ids.birthSerial}
                                                   className={"form-control" + (errors.birthSerial ? ' is-invalid' : '')}
                                                   value={birthSerial}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setBirthSerial(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.birthSerial = false;
                                                           return x;
                                                       });
                                                   }}
                                                   onKeyUp={e => {
                                                       const isExpanded = expanded;
                                                       if (e.which === 13) {
                                                           if (isExpanded)
                                                               (document.getElementById(ids.homeTell) as HTMLInputElement).focus();
                                                           else
                                                               saveChanges();
                                                       }
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.birthSerial ? 'd-block' : 'd-none')}>
                                                سریال شناسنامه صحیح نیست.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <button className={"expand-add-student" + (expanded ? ' active' : '')}
                                                    onClick={() => setExpanded(v => !v)}>
                                                {expanded ? 'موارد کمتر' : 'موارد بیشتر'}
                                                <ThinCaretDownIcon/>
                                            </button>
                                        </div>
                                        <div className={"col-lg-4" + (expanded ? '' : ' d-none')}>
                                            <label htmlFor={ids.homeTell}>تلفن ثابت:</label>
                                            <input type="text"
                                                   id={ids.homeTell}
                                                   className={"form-control" + (errors.homeTell ? ' is-invalid' : '')}
                                                   value={homeTell}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setHomeTell(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.homeTell = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.homeTell ? 'd-block' : 'd-none')}>
                                                تلفن ثابت صحیح نمی‌باشد.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label>تاریخ تولد:</label>
                                            <TimePicker
                                                lang={'fa'}
                                                hour={time.time[0]}
                                                minute={time.time[1]}
                                                setState={(h: number, m: number) => setTime(v => {
                                                    let x = {...v};
                                                    x.time[0] = h;
                                                    x.time[1] = m;
                                                    return x;
                                                })}
                                                title={''}
                                                locked={false}
                                                onSave={() => {
                                                }}
                                                date={time.date}  // gregorian
                                                setDate={(d: string) => setTime(v => {
                                                    let x = {...v};
                                                    x.date = d.split(" ")[0];
                                                    return x;
                                                })}
                                                hasDate={true}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.birthDate ? 'd-block' : 'd-none')}>
                                                تاریخ تولد صحیح نیست.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.fatherName}>نام پدر:</label>
                                            <input type="text"
                                                   id={ids.fatherName}
                                                   className={"form-control" + (errors.fatherName ? ' is-invalid' : '')}
                                                   value={fatherName}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setFatherName(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.fatherName = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.fatherName ? 'd-block' : 'd-none')}>
                                                لطفا حداقل ۲ کاراکتر وارد کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.fatherCert}>مدرک تحصیلی پدر:</label>
                                            <input type="text"
                                                   id={ids.fatherCert}
                                                   className={"form-control" + (errors.fatherCert ? ' is-invalid' : '')}
                                                   value={fatherCert}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setFatherCert(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.fatherCert = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.fatherCert ? 'd-block' : 'd-none')}>
                                                لطفا حداقل ۲ کاراکتر وارد کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.fatherJob}>شغل پدر:</label>
                                            <input type="text"
                                                   id={ids.fatherJob}
                                                   className={"form-control" + (errors.fatherJob ? ' is-invalid' : '')}
                                                   value={fatherJob}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setFatherJob(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.fatherJob = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.fatherJob ? 'd-block' : 'd-none')}>این
                                                فیلد را تکمیل کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.fatherTell}>تلفن پدر:</label>
                                            <input type="text"
                                                   id={ids.fatherTell}
                                                   className={"form-control" + (errors.fatherTell ? ' is-invalid' : '')}
                                                   value={fatherTell}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setFatherTell(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.fatherTell = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.fatherTell ? 'd-block' : 'd-none')}>این
                                                فیلد را تکمیل کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                        </div>
                                        <div className={"col-lg-4" + (expanded ? '' : ' d-none')}>
                                            <label htmlFor={ids.motherName}>نام و نام خانوادگی مادر:</label>
                                            <input type="text"
                                                   id={ids.motherName}
                                                   className={"form-control" + (errors.motherName ? ' is-invalid' : '')}
                                                   value={motherName}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setMotherName(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.motherName = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.motherName ? 'd-block' : 'd-none')}>این
                                                فیلد را تکمیل کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.motherCert}>مدرک تحصیلی مادر:</label>
                                            <input type="text"
                                                   id={ids.motherCert}
                                                   className={"form-control" + (errors.motherCert ? ' is-invalid' : '')}
                                                   value={motherCert}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setMotherCert(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.motherCert = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.motherCert ? 'd-block' : 'd-none')}>این
                                                فیلد را تکمیل کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.motherJob}>شغل مادر:</label>
                                            <input type="text"
                                                   id={ids.motherJob}
                                                   className={"form-control" + (errors.motherJob ? ' is-invalid' : '')}
                                                   value={motherJob}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setMotherJob(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.motherJob = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.motherJob ? 'd-block' : 'd-none')}>این
                                                فیلد را تکمیل کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.motherTell}>تلفن مادر:</label>
                                            <input type="text"
                                                   id={ids.motherTell}
                                                   className={"form-control" + (errors.motherTell ? ' is-invalid' : '')}
                                                   value={motherTell}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setMotherTell(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.motherTell = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.motherTell ? 'd-block' : 'd-none')}>این
                                                فیلد را تکمیل کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.zipcode}>کد پستی:</label>
                                            <input type="text"
                                                   id={ids.zipcode}
                                                   className={"form-control" + (errors.zipcode ? ' is-invalid' : '')}
                                                   value={zipcode}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setZipcode(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.zipcode = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.zipcode ? 'd-block' : 'd-none')}>
                                                کد پستی صحیح نیست.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.address}>نشانی منزل:</label>
                                            <input type="text"
                                                   id={ids.address}
                                                   className={"form-control" + (errors.address ? ' is-invalid' : '')}
                                                   value={address}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setAddress(t);
                                                       setErrors(v => {
                                                           let x = {...v};
                                                           x.address = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback " + (errors.address ? 'd-block' : 'd-none')}>این
                                                فیلد را تکمیل کنید.
                                            </div>
                                            <div style={{height: 20}}/>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center"
                                         style={{gap: 20, marginTop: (expanded ? 0 : 20)}}>
                                        <button className="cancel-button" onClick={props.closeHandler}>
                                            <b>انصراف</b>
                                        </button>
                                        <button className="btn-pay" onClick={saveChanges}>
                                            <b>ذخیره تغییرات</b>
                                        </button>
                                    </div>
                                </div>
                            </div> :
                            <div className="d-flex justify-content-center align-items-center"
                                 style={{padding: '100px 0'}}>
                                <div className="spinner-border" style={{color: '#0a53be'}}/>
                            </div>
                    }
                </div>
            </div>
        </>
    );
};